export { default } from "./QuestionText";
